import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { IModel } from '../../base/annotation';
import { akvToResource, akvToModel } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';

import {
    CognitiveServiceLinkedService
} from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CognitiveServiceLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                subscriptionId: '*',
                resourceGroup: '*',
                csName: '*',
                csKind: '*',
                csLocation: '*',
                endPoint: '*',
                csKey: 'secret'
            }
        }
    }
})

export class CognitiveServiceLinkedServiceAdapter extends LinkedServiceAdapter<CognitiveServiceLinkedService> {
    protected modelConstructor(): new () => CognitiveServiceLinkedService {
        return CognitiveServiceLinkedService;
    }

    protected model(): IModel {
        return CognitiveServiceLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: CognitiveServiceLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.CognitiveServiceLinkedService;

        properties.type = Metamodel.modelFor(CognitiveServiceLinkedService).name;
        properties.typeProperties = {
            subscriptionId: linkedService.subscriptionId,
            resourceGroup: linkedService.resourceGroup,
            csName: linkedService.csName,
            csKind: linkedService.csKind,
            csLocation: linkedService.csLocation,
            endPoint: linkedService.endPoint,
            csKey: akvToResource(linkedService.csKey, this.context)
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: CognitiveServiceLinkedService): Promise<CognitiveServiceLinkedService> {
        const properties = linkedServiceResource.properties as Model.CognitiveServiceLinkedService;
        linkedService.subscriptionId = properties.typeProperties.subscriptionId;
        linkedService.resourceGroup = properties.typeProperties.resourceGroup;
        linkedService.csName = properties.typeProperties.csName;
        linkedService.csKind = properties.typeProperties.csKind;
        linkedService.csLocation = properties.typeProperties.csLocation;
        linkedService.endPoint = properties.typeProperties.endPoint;
        linkedService.csKey = akvToModel(properties.typeProperties.csKey, this.context);
        return linkedService;
    }

}
